<template>
    <form action="#"
          @send.stop.prevent="send"
    >
        <div class="form-left">
            <div class="form-group">
                <input type="text"
                       class="form-control"
                       placeholder="Заявление о"
                       autocomplete="disable"
                       required
                       tabindex="5"
                       v-model="name"
                >
            </div>
            <div class="form-group">
                <input type="text"
                       class="form-control"
                       placeholder="конфиденциальности"
                       autocomplete="disable"
                       required
                       tabindex="10"
                       v-model="email"
                >
            </div>

<!--
            <div class="form-info">
                <b>Заявление о конфиденциальности:</b> Данный сайт&nbsp;не&nbsp;сохраняет,<br/>не&nbsp;обрабатывает и&nbsp;не&nbsp;публикует Ваши персональные данные.</b>
            </div>
-->

        </div>
        <div class="form-right">
            <div class="form-message">
                <textarea class="form-control"
                          placeholder="Данный сайт не сохраняет, не обрабатывает и не публикует Ваши персональные данные"
                          autocomplete="disable"
                          required
                          tabindex="15"
                          v-model="message"
                ></textarea>
            </div>
            
<!--
            <div class="form-submit">
                <button class="btn-action"
                        tabindex="20"
                        @click.stop.prevent="send"
                >Отправить</button>
            </div>
-->

        </div>
    </form>
</template>

<script>
    import axios from "axios";
    import messageModal from "../Modal/Message";
    import sentModal from "../Modal/Sent";

    const ACTION_URL = "/api/email";

    export default {
        name: "index",
        data() {
            return {
                name: null,
                email: null,
                message: null
            };
        },
        computed: {
            filled() {
                return this.name && this.email && this.message;
            }
        },
        methods: {
            send() {
                if ( ! this.filled) {
                    this.showMessage('Все поля обязательны для заполнения!');
                    return;
                }

                let formData = new FormData();
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("message", this.message);

                axios.post(ACTION_URL, formData)
                    .then((response) => {
                        if (response.data) {
                            this.message = null;
                            this.showSuccess();
                        }
                        else {
                            this.showMessage('Заполните поля корректными значениями.');
                        }
                    })
                    .catch(() => {
                        this.showMessage('Ошибка при отправке сообщения, обратитесь к администратору!');
                    });
            },
            showMessage(message) {
                this.$modal.show(messageModal, {
                    text: message
                }, {
                    height: "auto",
                    clickToClose: false,
                    adaptive: true,
                    scrollable: true
                });
            },
            showSuccess() {
                this.$modal.show(sentModal, null, {
                    height: "auto",
                    clickToClose: false,
                    adaptive: true,
                    scrollable: true
                });
            }
        }
    }
</script>